export interface CheckboxGridConfigs {
  labels: string[];
  isBulkSupported: boolean;
  isHintSupported: boolean;
}

export interface HeaderCellMap {
  label: string;
  values: boolean[];
  type: string;
}

export interface CheckboxGridRow {
  prop: string;

  primary_text?: string;

  secondary_text?: string;

  items: { type: string; value: boolean; label: string }[];
}

export interface GridCellAltCheckbox {
  checked: string;
  unchecked: string;
}
export interface GridCellItem {
  type: string;
  value: boolean;
  label?: string;
  altCheckbox?: GridCellAltCheckbox;
}

export interface CheckboxGridHeaderCell {
  label: string;
  prop: string;
}
